var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "multistepform" } },
    [
      _c("FormIndicator", {
        model: {
          value: _vm.step,
          callback: function($$v) {
            _vm.step = $$v
          },
          expression: "step"
        }
      }),
      _vm._v(" "),
      _vm.step == 1
        ? _c("div", { staticClass: "step step_1", attrs: { id: "step_1" } }, [
            _vm._m(0),
            _vm._v(" "),
            _c("h2", { staticClass: "bold_uppercase home" }, [
              _vm._v("What kind of café are you?")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "paragraph_header black" }, [
              _vm._v("Select one of the below to move on to the next section.")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "icon_row" }, [
              _c(
                "div",
                {
                  class: _vm.selectedClass(0, 1),
                  on: {
                    click: function($event) {
                      return _vm.select(0, 1)
                    }
                  }
                },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("a", { staticClass: "product_link" }, [
                    _vm._v("We're just getting started")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "paragraph_home icons_sec" })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: _vm.selectedClass(0, 2),
                  on: {
                    click: function($event) {
                      return _vm.select(0, 2)
                    }
                  }
                },
                [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("a", { staticClass: "product_link" }, [
                    _vm._v("We're an established café")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "paragraph_home icons_sec" })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: _vm.selectedClass(0, 3),
                  on: {
                    click: function($event) {
                      return _vm.select(0, 3)
                    }
                  }
                },
                [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("a", { staticClass: "product_link" }, [
                    _vm._v("We're part of a chain")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "paragraph_home icons_sec" })
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "product_icons_cta" }, [
              _c(
                "button",
                {
                  staticClass: "main_button business w-button",
                  attrs: { disabled: _vm.selection[0] == 0 },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.step++
                    }
                  }
                },
                [_vm._v("go to next step")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.step == 2
        ? _c("div", { staticClass: "step step_2", attrs: { id: "step_2" } }, [
            _vm._m(4),
            _vm._v(" "),
            _c("h2", { staticClass: "bold_uppercase home" }, [
              _vm._v("How many Coffees do you serve each day?")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "paragraph_header black" }, [
              _vm._v("If you're a start-up, let us know your estimate.")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "icon_row" }, [
              _c(
                "div",
                {
                  class: _vm.selectedClass(1, 1),
                  on: {
                    click: function($event) {
                      return _vm.select(1, 1)
                    }
                  }
                },
                [
                  _vm._m(5),
                  _vm._v(" "),
                  _c("a", { staticClass: "product_link" }, [_vm._v("1-50")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "paragraph_home icons_sec" })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: _vm.selectedClass(1, 2),
                  on: {
                    click: function($event) {
                      return _vm.select(1, 2)
                    }
                  }
                },
                [
                  _vm._m(6),
                  _c("a", { staticClass: "product_link" }, [_vm._v("50-120")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "paragraph_home icons_sec" })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: _vm.selectedClass(1, 3),
                  on: {
                    click: function($event) {
                      return _vm.select(1, 3)
                    }
                  }
                },
                [
                  _vm._m(7),
                  _c("a", { staticClass: "product_link" }, [_vm._v("120+")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "paragraph_home icons_sec" })
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "product_icons_cta" }, [
              _c(
                "button",
                {
                  staticClass: "main_button business w-button",
                  attrs: { disabled: _vm.selection[1] == 0 },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.step++
                    }
                  }
                },
                [_vm._v("go to next step")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.step == 3
        ? _c("div", { staticClass: "step step_3", attrs: { id: "step_3" } }, [
            _vm._m(8),
            _vm._v(" "),
            _c("h2", { staticClass: "bold_uppercase home" }, [
              _vm._v("Are you interested in café supplies too?")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "paragraph_header black" }, [
              _vm._v(
                "Supplies like tea, hot chocolate, snacks, barista equipment etc."
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "icon_row" }, [
              _c(
                "div",
                {
                  class: _vm.selectedClass(2, 1),
                  on: {
                    click: function($event) {
                      return _vm.select(2, 1)
                    }
                  }
                },
                [
                  _vm._m(9),
                  _vm._v(" "),
                  _c("a", { staticClass: "product_link" }, [
                    _vm._v("Sure, sounds interesting!")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "paragraph_home icons_sec" })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: _vm.selectedClass(2, 2),
                  on: {
                    click: function($event) {
                      return _vm.select(2, 2)
                    }
                  }
                },
                [
                  _vm._m(10),
                  _vm._v(" "),
                  _c("a", { staticClass: "product_link" }, [
                    _vm._v("Just coffee and/or machines, thanks")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "paragraph_home icons_sec" })
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "product_icons_cta" }, [
              _c(
                "button",
                {
                  staticClass: "main_button business w-button",
                  attrs: { disabled: _vm.selection[2] == 0 },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.finish()
                    }
                  }
                },
                [_vm._v("Finish")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "zigzag_divider _180" })
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "number_colour" }, [
      _c("h2", { staticClass: "heading" }, [_vm._v("1")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "coloured_div" }, [
      _c("img", {
        staticClass: "product_icon",
        attrs: {
          src: "/app/uploads/2020/06/New-Location-Icon-2.svg",
          width: "60",
          height: "60",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "coloured_div" }, [
      _c("img", {
        staticClass: "product_icon",
        attrs: {
          src: "/app/uploads/2020/06/Established-Business.svg",
          width: "60",
          height: "60",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "coloured_div" }, [
      _c("img", {
        staticClass: "product_icon",
        attrs: {
          src: "/app/uploads/2020/06/Chain-Cafe.svg",
          width: "60",
          height: "60",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "number_colour" }, [
      _c("h2", { staticClass: "heading" }, [_vm._v("2")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "coloured_div" }, [
      _c("img", {
        staticClass: "product_icon",
        attrs: {
          src: "/app/uploads/2020/06/Few-Cups_Quiet-Cafe1.svg",
          width: "60",
          height: "60",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "coloured_div" }, [
      _c("img", {
        staticClass: "product_icon",
        attrs: {
          src: "/app/uploads/2020/06/Mid-Size-Cafe.svg",
          width: "60",
          height: "60",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "coloured_div" }, [
      _c("img", {
        staticClass: "product_icon",
        attrs: {
          src: "/app/uploads/2020/06/Larger-Cafe.svg",
          width: "60",
          height: "60",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "number_colour" }, [
      _c("h2", { staticClass: "heading" }, [_vm._v("3")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "coloured_div" }, [
      _c("img", {
        staticClass: "product_icon",
        attrs: {
          src: "/app/uploads/2020/06/More-than-Coffee-Snacks.svg",
          width: "60",
          height: "60",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "coloured_div" }, [
      _c("img", {
        staticClass: "product_icon",
        attrs: {
          src: "/app/uploads/2020/06/Coffee-Beans-2.svg",
          width: "60",
          height: "60",
          alt: ""
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// C:/MAMP/htdocs/matthew-algie/public_html/app/themes/matthewalgie/node_modules/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"js":{"loader":"babel-loader","options":{"presets":[["@babel/preset-env",{"targets":{"browsers":["> .25%"]},"corejs":"2.0","useBuiltIns":"entry","forceAllTransforms":true,"ignoreBrowserslistConfig":false,"modules":false,"debug":true}]],"plugins":[["@babel/transform-runtime"],["@babel/plugin-transform-object-assign"]]}}}}!C:/MAMP/htdocs/matthew-algie/public_html/app/themes/matthewalgie/node_modules/vue-loader/lib?{"loaders":{"js":{"loader":"babel-loader","options":{"presets":[["@babel/preset-env",{"targets":{"browsers":["> .25%"]},"corejs":"2.0","useBuiltIns":"entry","forceAllTransforms":true,"ignoreBrowserslistConfig":false,"modules":false,"debug":true}]],"plugins":[["@babel/transform-runtime"],["@babel/plugin-transform-object-assign"]]}}}}!./scripts/vue/components/MultiStepForm.vue?vue&type=template&id=506ef178&
// module id = 112
// module chunks = 3